import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TabComponent, TabModule } from '@syncfusion/ej2-angular-navigations';
import { Subscription } from 'rxjs';
import { ExportInterfaceConfigurationFileProcessType } from 'src/app/base/models/models.swagger.generated';
import { TabConstantsFactory } from 'src/app/base/shared/syncfusion/tab-constants-factory';
import { ConfigurationsService } from '../../../configurations/configurations.service';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationFormFileFilterComponent } from './configuration-form-file-filter/configuration-form-file-filter.component';
import { ConfigurationFormFileLinebasedAllAttributesComponent } from './configuration-form-file-linebased-all-attributes/configuration-form-file-linebased-all-attributes.component';
import { ConfigurationFormFileFieldsComponent } from './configuration-form-file-fields/configuration-form-file-fields.component';
import { ConfigurationFormFileNameComponent } from './configuration-form-file-name/configuration-form-file-name.component';
import { Location } from '@angular/common';
import * as pages from './../../../../../core/routing/page-names';

@Component({
    selector: 'app-configuration-form-file',
    templateUrl: './configuration-form-file.component.html',
    styleUrls: ['./configuration-form-file.component.scss'],
    imports: [TabModule, ConfigurationFormFileNameComponent, ConfigurationFormFileFieldsComponent, ConfigurationFormFileLinebasedAllAttributesComponent, ConfigurationFormFileFilterComponent, TranslateModule]
})
export class ConfigurationFormFileComponent implements OnInit, OnDestroy {
  @ViewChild(TabComponent) public tab: TabComponent;

  private fileProcessTypeChangedSubscription: Subscription;

  constructor(public configurationFormService: ConfigurationFormCoordinatorService,
    public configurationService: ConfigurationsService,
    private location: Location
  ) { }

  ngOnInit() {
    this.fileProcessTypeChangedSubscription = this.configurationFormService.fileProcessTypeChanged.subscribe((fileProcessType: ExportInterfaceConfigurationFileProcessType) => {
      this.updateTabs(fileProcessType);
    });
  }

  ngOnDestroy(): void {
    this.fileProcessTypeChangedSubscription?.unsubscribe();
  }

  public animation = TabConstantsFactory.createStandardAnimationSettings();

  public select(event): void {
    if (event.isSwiped) {
      event.cancel = true;
    }
    this.setUrlRoute(event.selectingIndex);
  }

  public onTabsCreated(event: any) {
    this.updateTabs(this.configurationFormService.fileProcessType);
    this.getUrlRoute();
  }

  public getUrlRoute() {
    var url = this.location.path().split("/");
    var pageRoute = url[url.length - 1];

    switch (pageRoute) {
      case pages.configurationFileGeneralPageName:
        this.tab.select(0);
        break;
      case pages.configurationFileColumnBasedPageName:
        this.tab.select(1);
        break;
      case pages.configurationFileLineBasedPageName:
        this.tab.select(2);
        break;
      case pages.configurationFileFilterPageName:
        this.tab.select(3);
        break;
      default:
        this.tab.select(0);
        break;
    }
  }

  private setUrlRoute(index: number) {
    if (this.location.path().endsWith(pages.configurationFilePageName)) {
      this.location.replaceState(this.location.path() + "/" + pages.configurationFileGeneralPageName);
      return;
    }

    const base = this.location.path() + '/../';
    switch (index) {
      case 0:
        this.location.replaceState(base + pages.configurationFileGeneralPageName);
        break;
      case 1:
        this.location.replaceState(base + pages.configurationFileColumnBasedPageName);
        break;
      case 2:
        this.location.replaceState(base + pages.configurationFileLineBasedPageName);
        break;
      case 3:
        this.location.replaceState(base + pages.configurationFileFilterPageName);
        break;
    }
  }

  private updateTabs(fileProcessType: ExportInterfaceConfigurationFileProcessType) {
    this.tab?.hideTab(1, fileProcessType !== ExportInterfaceConfigurationFileProcessType.ColumnBased);
    this.tab?.hideTab(2, fileProcessType !== ExportInterfaceConfigurationFileProcessType.LineBased);
  }

}
